<template>
  <div class="pt-50 px-82.5 flex slide">
    <h4 class="fz-301 whitespace-nowrap" style="color: rgba(110, 117, 141, 1)">
      {{ text.maxTextTitle }}
    </h4>
    <div class="right-side ml-78">
      <p class="font-medium fz-201 mb-25">{{ text.maxText }}</p>
      <div
        class="line w-full h-px"
        style="background: rgba(151, 163, 203, 0.3)"
      ></div>
      <div class="content my-12.5 flex">
        <picture >
          <svg
            class="w-10 mr-22.5"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M38.75 26.25C38.75 27.3551 38.311 28.4149 37.5296 29.1963C36.7482 29.9777 35.6884 30.4167 34.5833 30.4167H9.58333L1.25 38.75V5.41667C1.25 4.3116 1.68899 3.25179 2.47039 2.47039C3.25179 1.68899 4.3116 1.25 5.41667 1.25H34.5833C35.6884 1.25 36.7482 1.68899 37.5296 2.47039C38.311 3.25179 38.75 4.3116 38.75 5.41667V26.25Z"
              stroke="#FF2E53"
              stroke-opacity="1"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M9.5 11.5H30"
              stroke="#FF2E53"
              stroke-opacity="1"
              stroke-width="2"
            />
            <path
              d="M10 20H21"
              stroke="#FF2E53"
              stroke-opacity="1"
              stroke-width="2"
            />
          </svg>
        </picture>
        <div class="flex flex-col w-3/4">
          <h5 class="fz-301 mb-7.5" style="color: #ff2e53">
            {{ text.needDigital }}
          </h5>
          <p class="fz-201">{{ text.myTask }}</p>
        </div>
      </div>
      <div
        class="line w-full h-px"
        style="background: rgba(151, 163, 203, 0.3)"
      ></div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "agencySlide2",
  computed: {
    text() {
      return require("@/assets/text/agency/slide2/" + this.lang + ".json");
    },
    ...mapState(['lang'])
  },
};
</script>

<style scoped></style>
